/* eslint-disable react/prop-types */
import React from 'react';
import Quiz from '~components/graphic/Quiz';
import Credits from '~components/base/Credits';
import Teasers from '~components/base/Teasers';

const ArchieElement = ({
  data, questions, candidates, smallimages, images, relatedLinks,
}) => {
  const archieObj = JSON.parse(data);

  // Here's where you handle the archie data.
  // for this interactive, I have quiz, teasers and credits
  // console.log(archieObj);

  if (archieObj.quiz) {
    return (
      <Quiz
        data={archieObj}
        questions={questions}
        candidates={candidates}
        smallimages={smallimages}
        images={images}
      />
    );
  }
  // case comments
  if (archieObj.comments) {
    return (
      <p className="discussion">
        <a href={archieObj.comments} className="benton-n6">Comments: Join the discussion</a>
      </p>
    );
  }
  // case teasers
  if (archieObj.teasers) {
    return (<Teasers relatedlinks={relatedLinks}>Up Next</Teasers>);
  }
  // case credits
  if (archieObj.credits) {
    return (<Credits data={archieObj} />);
  }

  return null;
};

export default ArchieElement;
